// theme constant
export const gridSpacing = { xs: 1.5, sm: 2, md: 3 };
export const drawerWidth = 260;
export const appDrawerWidth = 320;
